<template>
    <v-card>
        <v-card-text class="py-5">
            <div align="center" class="mb-5">
                <v-img
                    :src="require('@/assets/img/success.svg')"
                    height="90"
                    width="90"
                />
            </div>

            <div align="center">
                <template v-if="liveClassTotalErrorExcel > 0">
                    <div
                        class="font-weight-bold black--text mb-1"
                        style="font-size: 18px"
                    >
                        {{ liveClassTotal - liveClassTotalErrorExcel }}
                        dari {{ liveClassTotal }} Data Telah Terupload
                    </div>

                    <div>
                        Kami menemukan error pada berkas data Live Class.
                        Silahkan klik edit untuk memperbaiki sesuai dengan
                        detail kesalahan yang sudah tertera.
                    </div>

                    <div class="mt-7">
                        <v-btn
                            depressed
                            block
                            color="blew"
                            dark
                            @click="$emit('edit')"
                        >
                            Edit File
                        </v-btn>
                    </div>
                </template>

                <template v-else>
                    <div class="font-weight-bold black--text mb-1">
                        Seluruh Data Telah Terupload
                    </div>

                    <div class="mt-7">
                        <v-btn
                            depressed
                            block
                            color="blew"
                            dark
                            @click="$emit('finish')"
                        >
                            Selesai
                        </v-btn>
                    </div>
                </template>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    props: {
        liveClassTotal: { type: Number, default: 0 },
        liveClassTotalErrorExcel: { type: Number, default: [] },
    },
    name: "DialogSuccessUpload",
};
</script>



// WEBPACK FOOTER //
// DialogSuccessUpload.vue?6ceff7b2